import React from 'react';
import PropTypes from 'prop-types';
import ErrorBanner from '../../../components/ErrorBanner';

CancelledBanner.propTypes = {
  project: PropTypes.object.isRequired
};

export default function CancelledBanner(props) {
  const { project } = props;

  if (project.data.cancelled) {
    return (
      <ErrorBanner
        title="Project was cancelled for the following reason:"
        subtitle={project.data.cancelledMessage || '[No reason provided]'}
      />
    );
  }

  return null;
}
